import {
    getLocalizedString,
    OwaTimeformatLocalizedStringResourceId,
} from 'owa-timeformat/lib/localization/getLocalizedString';
import DayOfWeekType from '../../store/schema/DayOfWeekType';

export default function getLocalizedDayOfWeek(dayOfWeek: DayOfWeekType): string {
    return getLocalizedString(('calendarDayOfWeek_' +
        dayOfWeek) as OwaTimeformatLocalizedStringResourceId);
}
